import { forwardRef } from "react";
import CardFooter from "../card/cardFooter";
import { twMerge } from "tailwind-merge";

export interface ModalFooterProps
  extends React.HTMLAttributes<HTMLDivElement> {}

const ModalFooter = forwardRef<HTMLDivElement, ModalFooterProps>(
  (props, ref) => {
    return <CardFooter {...props} ref={ref} className={twMerge("justify-end", props.className)} />;
  }
);

export default ModalFooter;
